<template>
   <section id="add-workspace">
     <div class="row p-4">
     <div class="col-md-12">
		 <vue-form-generator
			ref="addEmailForm"
		  :schema="schemaStatus"
		  :model="modelform"
		  :options="formOptions">
		 </vue-form-generator>
		 If your domain is Outlook and not Gsuite, Plese leave empty workspace field.
	     <div class="col-md-12">
	         <button v-if="!saving" class="btn btn-sm btn-primary" @click="save">{{ $t("lang.button.save") }}</button>
	     </div>
     </div>
     <span
       v-if="saving"
      class="loadingres mr-2 ml-2 spinner-border loading-spinner"></span>
     </div>
   </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VueFormGenerator from "vue-form-generator";
import { usersService,workspaceService } from "@/_services";

export default {
    props: {
        sales_representative_id: false,
        workspaces:false,
    },
	 created() {
	 },
    data() {
        return {
        	saving:false,
        	workspace_id:false,
        	client_id:false,
            editing: false,
            editingEmail: "",
            alertMessage: "",
			modelform:{
                domain: ""
            },
			schemaStatus: {
        	   fields: [
              		{
	                    type: "input",
	                    inputType: "text",
	                    label: "Domain",
	                    model: "domain",
	                    id:"domain",
			            featured: true,
			            required: true,
	                    placeholder: "ex : domain.com",
	                    styleClasses: "col-md-4"
                   },
		          {
		            type: "select",
		            inputType: "text",
		            label: "Workspace",
		            model: "workspace_id",
		            readonly: false,
		            required: false,
		            disabled: false,
		            selectOptions: {},
		            values: () => {
		              return this.workspaces;
		            },
		            styleClasses: "col-sm-6 col-md-3",
		          },
		        ],
		      },
		    formOptions: {
		        validateAfterLoad: false,
		        validateAfterChanged: true,
		    },
		 }
	
		},
		methods: {
			save(){
				this.$refs.addEmailForm.validate();
				this.saving = true;
				workspaceService.addDomain(this.sales_representative_id,this.modelform).then((result) => {	
					
					this.$emit("done");

		      	});
			}
		}
	}
</script>